// add the beginning of your app entry
// import 'vite/modulepreload-polyfill'
import { css, Global } from '@emotion/react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { appRouter } from '@routes/routes';
import {
  initializeAxios,
  AuthProvider,
  initializeSocialKeys,
  initializeGoogleMapsAPIKey,
  GlobalModalsProvider,
} from '@staffedupusa/shared-components';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import 'react-toastify/dist/ReactToastify.css';

import { RouterProvider } from 'react-router-dom';
import { Slide, ToastContainer } from 'react-toastify';

import {
  lightGrey,
  primaryGrey,
  primaryRed,
  successGreen,
} from '@styles/colors';
import appTheme from '@styles/theme';
import '../../../../../i18n';
import { UserCountryProvider } from '@context/UserCountryContext';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const Main = () => {
  const globalModals = {
    employerSignUpModal: false,
    signInModal: false,
  };

  initializeGoogleMapsAPIKey(import.meta.env.VITE_GOOGLE_MAPS_API_KEY);
  initializeAxios(import.meta.env.VITE_API_BASE_URL);
  initializeSocialKeys({
    googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID,
    facebookAppId: import.meta.env.VITE_FACEBOOK_APP_ID,
    linkedInClientId: import.meta.env.VITE_LINKEDIN_CLIENT_ID,
  });

  return (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <GlobalModalsProvider initialModals={globalModals}>
          <ThemeProvider theme={appTheme}>
            <CssBaseline enableColorScheme />
            <AuthProvider>
              <UserCountryProvider>
                <Global
                  styles={css`
                    @import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');

                    :root {
                      --toastify-icon-color-success: ${successGreen};
                      --toastify-icon-color-error: ${primaryRed};
                      --toastify-color-light: ${lightGrey};
                      --toastify-text-color-light: ${primaryGrey};

                      --toastify-color-progress-success: ${successGreen};
                      --toastify-color-progress-error: ${primaryRed};
                    }
                  `}
                />
                <ToastContainer
                  position="bottom-left"
                  autoClose={3000}
                  closeOnClick
                  theme="light"
                  transition={Slide}
                />
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <RouterProvider router={appRouter} />
                </LocalizationProvider>
              </UserCountryProvider>
            </AuthProvider>
          </ThemeProvider>
        </GlobalModalsProvider>
      </QueryClientProvider>
    </React.StrictMode>
  );
};

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <Main />,
);
